jQuery(document).ready(function ($) {
    ({
        init: function () {
            this.top_slider();
            this.cat_margin_top();
            this.blog_slider();
            this.load();
            this.resize();
            this.slide_brand();
            $("*[data-sr]").length && ScrollReveal().reveal("*[data-sr]");
        },
        top_slider: function () {
            var section = $('.section-topbanner');
            var slider = section.find('.slider-list>div');
            var item = slider.find('.item');
            if (item.length > 1) {
                slider.bxSlider({
                    speed: 1200,
                    pause: 9000,
                    controls: false,
                    auto: true,
                    // mode:'fade',
                    onSliderLoad: function (current) {
                        var slider = $('#top-slider');
                        var sh = slider.height();
                        var text = slider.find('.card-text >div');
                        var th = text.height();
                        slider.find('.bx-pager').css('margin-top', (sh - th) / 4);
                    },
                });
            }
        },
        cat_margin_top: function () {
            var slider = $('#top-slider');
            var sh = slider.height();
            var text = slider.find('.card-text >div');
            var th = text.height();
            if ((sh - th) / 4 > 0) {
                $('#category-list').css('margin-top', '-' + (sh - th) / 4 + 'px');
            } else {
                $('#category-list').css('margin-top', 0);
            }
        },
        blog_slider: function () {
            var section = $('.section-article');
            var slider = section.find('.card-list-slider');
            var item = slider.find('.card-item');
            if (item.length > 2) {
                slider.removeClass('row');
                slider.bxSlider({
                    speed: 1200,
                    pause: 9000,
                    slideWidth: 600,
                    minSlides: $(window).width() > 575 ? 2 : 1,
                    maxSlides: 2,
                    slideMargin: 0,
                    moveSlides: 1,
                    onSliderLoad: function (current) {
                        var pageritem = section.find('.bx-pager-item');
                        var len = pageritem.length;
                        pageritem.each(function () {
                            var index = $(this).index();
                            $(this).css('width', 100 / len * (index + 1) + '%')
                        })
                    },
                });
            }
        },
        load: function () {
            $(window).load(function () {

            })
        },
        
        resize: function () {
            var t = this;
            $(window).resize(function () {
                t.cat_margin_top();
            })
        },
        slide_brand: function () {
            $('.multiple-items').slick({
                dots: false,
                infinite: true,
                slidesToShow: 7,
                // slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
                speed: 150,
                arrows: true

            }); 
            
        }
    }).init()
});


